import { Booth } from "src/components/Booth";
import assets from "../assets";
import { achievement } from "../utils";

const Booths = () => {
    const booths = Object.keys(assets.expo_hall.booths).map((boothName, idx) => {
        const booth = assets.expo_hall.booths[boothName]
        const row = idx === 0 ? 0 : Math.trunc(idx/ 3)
        const leftSt = idx - (3 * row)

        const {achievements} = assets.expo_hall

        return <Booth boothId={booth}
            onLinkClick={name => {
                if (achievements[name] && achievements[name][boothName]) {
                    achievement(achievements[name][boothName])
                }
            }}
            position={{
                left: `${4 + (32 * (leftSt))}%`,
                top: `${24 + (40 * (row))}%`,
                width: "30%"
            }}
        />
    })
    return booths
}

export default {
    background: assets.expo_hall.df,
    name: "expo-hall",
    navName: "Ontario Showcase",
    links: [		{
			height: "7.3%",
			label: "Back to Atrium",
			href:"/atrium",
			left: "3.9%",
			top: "4%",
			width: "13%"
		}],
    extras: <>
        <Booths />
    </>
}
